// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7f35897b","239":"28b680d1","455":"2a6c76ed"}[chunkId] + ".chunk.js";
};